import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ActionButton as mainModule } from './main';
import * as Config from './config';
import { init as mainTheme } from './themes/main';

declare var require: any;

require('../sass-main/pdc-widget-action-button.sass');

export class ActionButton extends WidgetBase {
    public static _name: string = Config.name;
    public static moduleName: string = Config.moduleName;
    public static group: string = Config.group;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;
    public static themeModule = mainTheme;

    public static load() {
        const def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-action-button'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ActionButton);
